import React from "react";

import { Button, Stack, TextField, Typography } from "@mui/material";

import { validField } from "../../../valid-string";

interface ClientGeneralTabProps {
  initialClientName: string;
  onSave: (clientName: string) => void;
  isSaving?: boolean;
}

const ClientGeneralTab: React.FC<ClientGeneralTabProps> = ({
  initialClientName,
  onSave,
  isSaving,
}) => {
  const [clientName, setClientName] = React.useState(initialClientName);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    setClientName(initialClientName);
    setError("");
  }, [initialClientName]);

  const trimmedName = clientName.trim();
  const isDirty = trimmedName !== initialClientName;
  const saveDisabled = isSaving || !trimmedName || !isDirty;

  const handleSave = () => {
    if (!validField(trimmedName, 3, 64)) {
      setError("Client name must be 3-64 characters and use valid characters");
      return;
    }

    setError("");
    onSave(trimmedName);
  };

  return (
    <Stack spacing={2} sx={{ px: 2, pb: 2, pt: 1 }}>
      <TextField
        label="Client Name"
        size="small"
        fullWidth
        value={clientName}
        onChange={(event) => {
          setClientName(event.target.value);
          if (error) {
            setError("");
          }
        }}
        error={Boolean(error)}
        helperText={error}
      />
      <Stack direction="row" >
        <Button fullWidth variant="contained" disabled={saveDisabled} onClick={handleSave}>
          Save changes
        </Button>
      </Stack>
    </Stack>
  );
};

export default ClientGeneralTab;
